import React, { createContext, useContext, useState } from "react"

const SortContext = createContext(null)

export function SortProvider({ children }) {
    const [selectedOption, setSelectedOption] = useState("")
    const [selectedCategory, setSelectedCategory] = useState("")

    return (
        <SortContext.Provider value={{ selectedOption, setSelectedOption, selectedCategory, setSelectedCategory }}>
            {children}
        </SortContext.Provider>
    )
}

export function useSortContext() {
    const ctx = useContext(SortContext)
    if (!ctx) throw new Error("useSortContext must be used within a SortProvider")
    return ctx
}

/**
 * Master project list with dates and categories.
 * Single source of truth shared by ImageGrid and ProjectNavigation.
 */
/**
 * To change the default grid/navigation order, update the `order` field here.
 * Both ImageGrid and ProjectNavigation read from this single list.
 */
export const PROJECT_LIST = [
    {
        path: "/under-armour-second-nature",
        name: 'Under Armour "Second Nature"',
        date: "2025-08-06",
        order: 1,
        categories: ["apparel"],
    },
    {
        path: "/saga-adaptive-apparel",
        name: "SAGA Adaptive Apparel",
        date: "2025-12-12",
        order: 2,
        categories: ["apparel"],
    },
    {
        path: "/alo-apparel-brief",
        name: "ALO Apparel Brief",
        date: "2026-03-09",
        order: 3,
        categories: ["apparel"],
    },
    {
        path: "/adaptive-study",
        name: "Adaptive Study",
        date: "2025-12-10",
        order: 4,
        categories: ["apparel", "footwear"],
    },
    {
        path: "/senior-footwear-design-prototype",
        name: "Senior Footwear Design Prototype",
        date: "2025-12-05",
        order: 5,
        categories: ["footwear"],
    },
    {
        path: "/nike-ata",
        name: 'Nike "Attire for All"',
        date: "2024-10-13",
        order: 6,
        categories: ["apparel", "footwear"],
    },
    {
        path: "/levi-respirate",
        name: 'Levi Strauss & Co. "Respirate"',
        date: "2023-10-13",
        order: 7,
        categories: ["apparel"],
    },
    {
        path: "/spydercsu",
        name: "Spyder x CSU",
        date: "2024-12-05",
        order: 8,
        categories: ["apparel"],
    },
    {
        path: "/scandinavian-neck-gaiter",
        name: "Scandinavian Neck Gaiter",
        date: "2024-12-12",
        order: 9,
        categories: ["accessories"],
    },
    {
        path: "/canoe-bag",
        name: "Canoe Bag",
        date: "2025-05-13",
        order: 10,
        categories: ["accessories"],
    },
    {
        path: "/budai-wallet",
        name: "Budai Wallet",
        date: "2025-03-04",
        order: 11,
        categories: ["accessories"],
    },
]
